module.exports = __webpack_public_path__ + "static/media/buraco_negro.2de68933.png";